var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h2", [_vm._v("Referral Program Dashboard")]),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-share stat-icon",
                      staticStyle: { color: "#409eff" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Total Referrals"),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.statistics.totalReferrals || 0)),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("All time"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-time stat-icon",
                      staticStyle: { color: "#e6a23c" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Pending"),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.statistics.pendingReferrals || 0)),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("Awaiting purchase"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-check stat-icon",
                      staticStyle: { color: "#67c23a" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Completed"),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.statistics.completedReferrals || 0)),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("Successfully converted"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-present stat-icon",
                      staticStyle: { color: "#f56c6c" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Bonus Days Granted"),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(_vm.statistics.totalBonusDaysGranted || 0)
                        ),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("VA days given"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "period-stat" }, [
                  _c("span", { staticClass: "period-label" }, [
                    _vm._v("This Week"),
                  ]),
                  _c("span", { staticClass: "period-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.statistics.periodStats?.newReferralsThisWeek || 0
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "period-sub" }, [
                    _vm._v("new referrals"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "period-stat" }, [
                  _c("span", { staticClass: "period-label" }, [
                    _vm._v("This Month"),
                  ]),
                  _c("span", { staticClass: "period-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.statistics.periodStats?.newReferralsThisMonth || 0
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "period-sub" }, [
                    _vm._v("new referrals"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "period-stat" }, [
                  _c("span", { staticClass: "period-label" }, [
                    _vm._v("Conversion Rate"),
                  ]),
                  _c("span", { staticClass: "period-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatPercent(
                          _vm.statistics.periodStats?.conversionRate
                        )
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "period-sub" }, [
                    _vm._v("completed / total"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "filter-container",
          staticStyle: { "margin-top": "30px" },
        },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Status", clearable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            [
              _c("el-option", { attrs: { label: "All", value: "" } }),
              _c("el-option", {
                attrs: { label: "Pending", value: "pending" },
              }),
              _c("el-option", {
                attrs: { label: "Completed", value: "completed" },
              }),
              _c("el-option", {
                attrs: { label: "Rewarded", value: "rewarded" },
              }),
              _c("el-option", {
                attrs: { label: "Expired", value: "expired" },
              }),
              _c("el-option", {
                attrs: { label: "Cancelled", value: "cancelled" },
              }),
            ],
            1
          ),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "Start Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-refresh" },
              on: { click: _vm.loadData },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            data: _vm.list,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", align: "center", width: "70" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.id) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Referrer", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(row.referrerEmail || row.referrerUserId)),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "11px", color: "#909399" },
                      },
                      [_vm._v("Code: " + _vm._s(row.referralCode))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Referred User", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.referredEmail || row.referredUserId) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusType(row.status),
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.status) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Created", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(_vm.formatDate(row.createdAt)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Completed", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.completedAt
                            ? _vm.formatDate(row.completedAt)
                            : "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Rewarded", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.rewardedAt ? _vm.formatDate(row.rewardedAt) : "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "180",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status === "pending"
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleComplete(row)
                              },
                            },
                          },
                          [_vm._v(" Complete ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "info",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(row)
                          },
                        },
                      },
                      [_vm._v(" Details ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [10, 20, 30, 50],
          "page-size": _vm.listQuery.limit,
          total: _vm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Referral Details",
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.selectedReferral
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                    _vm._v(_vm._s(_vm.selectedReferral.id)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Status" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getStatusType(
                              _vm.selectedReferral.status
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.selectedReferral.status) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referrer User ID", span: 2 } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.selectedReferral.referrerUserId) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referrer Email", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedReferral.referrerEmail || "N/A") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referred User ID", span: 2 } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.selectedReferral.referredUserId) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referred Email", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedReferral.referredEmail || "N/A") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referral Code" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.selectedReferral.referralCode) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Created At" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(_vm.selectedReferral.createdAt)
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Completed At" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedReferral.completedAt
                              ? _vm.formatDate(_vm.selectedReferral.completedAt)
                              : "N/A"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Rewarded At" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedReferral.rewardedAt
                              ? _vm.formatDate(_vm.selectedReferral.rewardedAt)
                              : "N/A"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Expires At" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedReferral.expiresAt
                              ? _vm.formatDate(_vm.selectedReferral.expiresAt)
                              : "N/A"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Purchase ID" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedReferral.qualifyingPurchaseId || "N/A"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referrer Bonus Entitlement", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedReferral.referrerBonusEntitlementId ||
                              "Not yet granted"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Referred Bonus Entitlement", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedReferral.referredBonusEntitlementId ||
                              "Not yet granted"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "Metadata", span: 2 } },
                    [
                      _vm.selectedReferral.metadataJson
                        ? _c(
                            "pre",
                            {
                              staticStyle: {
                                background: "#f5f5f5",
                                padding: "10px",
                                "border-radius": "4px",
                                "max-height": "150px",
                                overflow: "auto",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  JSON.stringify(
                                    _vm.selectedReferral.metadataJson,
                                    null,
                                    2
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("span", [_vm._v("N/A")]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }